/**
 * @file Utility that needs description.
 * @copyright Copyright (c) 2018-present, Graham Fairweather
 * @module final
 */

import drop from './drop';

export default function final(array) {
  return drop(array);
}
